import { Link } from "react-router-dom";
import { getLatestMovies } from "@/utils/movieUtils";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function LatestSection() {
  const latest = getLatestMovies(8);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-8 md:px-8 md:py-10">
      <SectionHeading
        title="最新影视推荐"
        subtitle="近期上线的优质日本电影与电视剧"
        icon="ri-time-line"
        action={
          <Link
            to="/category/movie"
            className="hidden items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 sm:flex whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-2 gap-3 md:gap-5 sm:grid-cols-3 lg:grid-cols-4">
        {latest.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}